export const typeOfUser = [
    'Owner',
    'Independent agent',
    'Big broker',
    'Medium broker',
    'Enterprise',
]


//Origen de las propiedades

export const fromData = {
    'Sin Origen': 'sin',
    'Softec ': 1,
    'Ruv': 2,
    'Catastro ': 3,
    'Showroom ': 4,
    'Habi': 5,
    'Habi_cta ': 6,
    'Habi_last': 7,
    'Pcometro ': 8,
    'Analogo ': 9,
}

export const fromDataList = Object.entries(fromData).map(([key, value]) => ({ label: key, value }));
